import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d9ede40"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mask"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "banner-title" }
const _hoisted_4 = { class: "banner-desc" }

import { withDefaults } from 'vue';

  export interface IProps {
    height?: string;
    title?: string;
    desc?: string;
    image: string;
    textCenter?: boolean;
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    height: null,
    title: { default: '' },
    desc: { default: '' },
    image: null,
    textCenter: { type: Boolean, default: false }
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "banner",
    style: _normalizeStyle({ backgroundImage: `url('${__props.image}')` })
  }, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      (__props.title)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: _normalizeClass(["box-text", { 'text-center': __props.textCenter }])
              }, [
                _createElementVNode("h2", _hoisted_3, _toDisplayString(__props.title), 1),
                _createElementVNode("p", _hoisted_4, _toDisplayString(__props.desc), 1)
              ], 2)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 4))
}
}

})